const LegendCustom = ({ datasets }: { datasets: any[] }) => {
    return (
        <div className="custom-legend">
            {datasets.map((ds, index) => (
                <div key={index} className="legend-item">
                    <span
                        className="legend-color"
                        style={{ backgroundColor: ds.borderColor }}
                    />
                    <span className="legend-label">{ds.label}</span>
                </div>
            ))}
        </div>
    );
};

export default LegendCustom;